const filterMenu = document.getElementById('menu-filter_aside');
const filterBars = document.getElementById('filter-bars');
const filterClose = document.getElementById('filter-close');

if(filterBars != null && filterClose != null){
  filterBars.addEventListener('click', () => {
    filterMenu.classList.add('show_filter-block');    
    filterClose.classList.remove('hide_element-in_filter');    
    //filter-bars.classList.add('hide_element-in_filter');    
  })
  filterClose.addEventListener('click', () => {
    filterMenu.classList.remove('show_filter-block');    
    filterClose.classList.add('hide_element-in_filter');    
    //filter-bars.classList.remove('hide_element-in_filter');    
  })
}